import { useQuery } from "hooks/useQuery";
import { getChartFetchData } from "../service";
import { getShillerPEChartFilteredData } from "../utils";
import { getSectorLineColors } from "features/Strategy/utils";

export const useShillerPEChart = (period = "") => {
  const { isLoading, data } = useQuery({
    queryKey: ["shillerPEChart", period],
    queryFn: async () => {
      const response = await getChartFetchData({
        datasource_name: "shiller_pe",
        period,
      });

      const filteredData = getShillerPEChartFilteredData(
        response.external_data.data
      );

      const lineColors = getSectorLineColors(filteredData);

      return {
        chartData: filteredData,
        chartLineColors: lineColors,
      };
    },
    enabled: true,
  });

  return {
    isLoading,
    chartData: data?.chartData || [],
    chartLineColors: data?.chartLineColors || [],
  };
};
